var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77 23.75C5.19417 23.75 4.71375 23.5575 4.32875 23.1725C3.94375 22.7875 3.75083 22.3067 3.75 21.73V8.27C3.75 7.69417 3.94292 7.21375 4.32875 6.82875C4.71458 6.44375 5.19458 6.25083 5.76875 6.25H24.2313C24.8062 6.25 25.2863 6.44292 25.6713 6.82875C26.0563 7.21458 26.2492 7.695 26.25 8.27V21.7313C26.25 22.3062 26.0571 22.7867 25.6713 23.1725C25.2854 23.5583 24.8054 23.7508 24.2313 23.75H5.77ZM15 15.145L25 8.60625L24.615 7.5L15 13.75L5.385 7.5L5 8.60625L15 15.145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.9733d49af8d6fe337479d0fb9c5f1239.svg";
export { ForwardRef as ReactComponent };